import * as Telecom from '@servicetitan/telecom-rtcs-client';
import log from '../../lib/log';
import getQueue from '../../lib/getQueue';
import { refreshQueueOnCacheMiss } from '../../lib/refreshQueue';

async function handleQueueAgentRemoved(event: Telecom.QueueAgentRemovedEvent) {
  const queue = getQueue(event.queueId);

  log('rtcs:queue:agent_removed:' + queue?.name, event);

  if (!queue) {
    await refreshQueueOnCacheMiss(event.queueId);
    return;
  }

  queue.memberIds = queue.memberIds.filter(
    (memberId) => memberId !== event.agentId,
  );
}

export default handleQueueAgentRemoved;
